(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace-competition/overview-hero/assets/javascripts/content/competition-closed-draw-defined.js') >= 0) return;  svs.modules.push('/components/marketplace-competition/overview-hero/assets/javascripts/content/competition-closed-draw-defined.js');

'use strict';

const {
  useMemo
} = React;
const {
  clx
} = svs.components.lbUtils;
const {
  formatDate
} = svs.components.lbUtils.helpers.formatDate;
const {
  CompetitionLogo,
  LoginButton,
  TrixaButton
} = svs.components.marketplaceCompetition.overviewHero.common;
const {
  resolveCompetitionName
} = svs.components.marketplaceCompetition.helpers;
const {
  capitalize,
  ordinalNumber
} = svs.components.marketplaceCompetition.overviewHero.helpers;
const {
  useMobileQuery,
  useTrixa
} = svs.components.marketplaceCompetition.overviewHero.hooks;
const {
  IS_NOT_REGISTERED,
  HAS_NO_CURRENT_BET,
  HAS_CURRENT_BET
} = svs.components.marketplaceCompetition.overviewHero.constants.OverviewUserState;
const UserNotLoggedIn = _ref => {
  let {
    competition
  } = _ref;
  return React.createElement(React.Fragment, null, React.createElement(CompetitionLogo, {
    competition: competition
  }), React.createElement("div", {
    className: "competition-overview-hero-content"
  }, React.createElement("div", {
    className: "overview-hero-title"
  }, React.createElement("span", null, "Logga in f\xF6r att se"), React.createElement("span", null, "dina resultat")), React.createElement(LoginButton, {
    isVisible: true
  })));
};
const UserNotRegistered = _ref2 => {
  let {
    competition,
    isMobile,
    showTrixa
  } = _ref2;
  return React.createElement(React.Fragment, null, React.createElement(CompetitionLogo, {
    competition: competition
  }), React.createElement("div", {
    className: "competition-overview-hero-content"
  }, React.createElement("div", {
    className: "overview-hero-title"
  }, React.createElement("span", null, "T\xE4vlingen har startat!")), !isMobile && React.createElement("div", {
    className: "overview-hero-sub"
  }, React.createElement("span", null, "Men du kan ist\xE4llet t\xE4vla i antal kickar")), React.createElement(TrixaButton, {
    isVisible: !isMobile,
    onClick: showTrixa
  })));
};
const UserHasNoBet = _ref3 => {
  let {
    competition,
    compName
  } = _ref3;
  return React.createElement(React.Fragment, null, React.createElement(CompetitionLogo, {
    competition: competition
  }), React.createElement("div", {
    className: "competition-overview-hero-content"
  }, React.createElement("div", {
    className: "overview-hero-title"
  }, React.createElement("span", null, "Du deltar i ".concat(compName)))));
};
const UserHasBet = _ref4 => {
  var _competition$currentD;
  let {
    competition
  } = _ref4;
  const {
    firstDrawNumber,
    currentDrawNumber
  } = (competition === null || competition === void 0 ? void 0 : competition.details) || {};
  const closeTime = (_competition$currentD = competition.currentDraw) !== null && _competition$currentD !== void 0 && _competition$currentD.regCloseTime ? formatDate(competition.currentDraw.regCloseTime, true, true) : null;
  const currentGameTitle = useMemo(() => {
    if (firstDrawNumber && currentDrawNumber) {
      const round = currentDrawNumber - firstDrawNumber + 1;
      return React.createElement(React.Fragment, null, React.createElement("span", null, "Du har l\xE4mnat in spelet till"), React.createElement("span", null, "".concat(ordinalNumber(round), " omg\xE5ngen")));
    }
    return React.createElement("span", null, "Du har l\xE4mnat in spelet f\xF6r omg\xE5ngen!");
  }, [currentDrawNumber, firstDrawNumber]);
  return React.createElement(React.Fragment, null, React.createElement(CompetitionLogo, {
    competition: competition
  }), React.createElement("div", {
    className: "competition-overview-hero-content"
  }, React.createElement("div", {
    className: "overview-hero-title"
  }, currentGameTitle), closeTime && React.createElement("div", {
    className: "overview-hero-sub-small"
  }, "Spelet startar ".concat(capitalize(closeTime)))));
};
const CompetitionClosedDrawDefined = _ref5 => {
  let {
    branding,
    competition,
    userState
  } = _ref5;
  const compName = resolveCompetitionName(competition);
  const isMobile = useMobileQuery();
  const [showTrixa, Trixa] = useTrixa();
  const renderContentBasedOnUserState = state => {
    switch (state) {
      case IS_NOT_REGISTERED:
        return React.createElement(UserNotRegistered, {
          competition: competition,
          isMobile: isMobile,
          showTrixa: showTrixa
        });
      case HAS_NO_CURRENT_BET:
        return React.createElement(UserHasNoBet, {
          competition: competition,
          compName: compName
        });
      case HAS_CURRENT_BET:
        return React.createElement(UserHasBet, {
          competition: competition
        });
      default:
        return React.createElement(UserNotLoggedIn, {
          competition: competition
        });
    }
  };
  if (Trixa) {
    return React.createElement(Trixa, {
      active: true,
      branding: branding,
      classNames: "competition-overview-hero competition-closed-draw-defined"
    });
  }
  return React.createElement("div", {
    className: clx('competition-overview-hero competition-closed-draw-defined', userState)
  }, renderContentBasedOnUserState(userState));
};
setGlobal('svs.components.marketplaceCompetition.overviewHero.content.CompetitionClosedDrawDefined', CompetitionClosedDrawDefined);

 })(window);